<template>
  <transition name="dwp-loading-fade" @after-leave="handleAfterLeave">
    <div
      v-show="visible"
      class="dwp-loading-mask"
      :style="{ backgroundColor: background || '' }"
      :class="[customClass]"
    >
      <div class="dwp-loading-spinner">
        <svg v-if="!spinner" class="circular" viewBox="25 25 50 50">
          <circle class="dwp-loading-path" cx="50" cy="50" r="20" fill="none" />
        </svg>
        <component :is="spinner"></component>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      spinner: null,
      background: null,
      fullscreen: true,
      visible: false,
      customClass: ""
    };
  },
  methods: {
    handleAfterLeave() {
      this.$emit("after-leave");
    }
  }
};
</script>